import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
	name: 'user',
	initialState: {
		value: { loggedIn: false, pex: {}, data: {}, group: {} },
	},
	reducers: {
		setLoggedIn: (state, action) => {
			state.value.loggedIn = action.payload
		},
		setPex: (state, action) => {
			state.value.pex = action.payload
		},
		setData: (state, action) => {
			state.value.data = action.payload
		},
		setGroup: (state, action) => {
			state.value.group = action.payload
		},
	},
})

export const { setLoggedIn, setPex, setData, setGroup } = userSlice.actions

export default userSlice.reducer
